<template>
  <div class="balance-wrap">
    <div v-if="!app.balanceCad" class="box">
      <h2 class="title">{{ $t("balance.header.title") }}</h2>
      <p :class="{ balance: true, 'is-regular': true }">
        <span
          >R$
          {{
            $auth.user().funds.amount
              | currency("", 2, { decimalSeparator: "," })
          }}</span
        >
      </p>

      <button class="button is-primary is-large" @click="purchase">
        {{ $t("global.buy") }}
      </button>
    </div>
    <div v-else class="box">
      <h2 class="title">
        {{ $t("balance.header.title") }}
        <span v-if="fundsFiltered.length > 1"
          >{{ $t("balance.header.title2") }}
        </span>
        <small v-if="fundsFiltered.length > 1"
          ><a href="#" class="button is-text is-small" @click="view">{{
            $t("balance.header.details")
          }}</a></small
        >
      </h2>
      <p
        v-for="fund in fundsFiltered"
        :key="fund.key"
        :class="{
          balance: true,
          'is-regular': fund.type === 'REGULAR',
          'is-bonus': fund.type === 'BONUS',
        }"
      >
        <span>{{ $root.app.city === 'MCL' ? $auth.user().funds.shouAsAmount ? $auth.user().funds.amount : $auth.user().funds.cads : fund.quantity }}</span>
        {{
          $root.app.city === 'MCL' ?
          $options.filters.pluralize(
            $auth.user().funds.shouAsAmount ? $auth.user().funds.amount : $auth.user().funds.cads,
            $root.app.product,
            $root.app.productPlural
          ):
          fund.title ||
          $options.filters.pluralize(
            fund.quantity,
            $root.app.product,
            $root.app.productPlural
          )
        }}
      </p>

      <button class="button is-primary is-large" @click="purchase">
        {{ $t("global.buy") }}
      </button>
    </div>

    <zul-modal
      ref="balanceModal"
      :title="$t('balance.balanceAvailable.title')"
      :primary="$t('global.buy')"
      @primary="purchase"
    >
      <div class="balance-modal">
        <h3 class="title">{{ $t("balance.balanceAvailable.title2") }}</h3>
        <cad v-for="fund in funds" :key="fund.key" :data="fund"></cad>

        <div v-for="vehicle in vehicles" :key="vehicle.registrationPlate">
          <h3
            :class="{
              title: true,
              'has-icon': true,
              car: vehicle.funds[0].vehicleType === 'CAR',
              motorcycle: vehicle.funds[0].vehicleType === 'MOTORCYCLE',
            }"
          >
            {{ vehicle.registrationPlate }}
          </h3>
          <cad
            v-for="fund in vehicle.funds"
            :key="fund.type"
            :data="fund"
          ></cad>
        </div>
      </div>
    </zul-modal>

    <zul-modal ref="purchaseModal" :title="modalTitle" @primary="confirm">
      <header class="order-steps">
        <button
          @click="setStep(1)"
          :class="{
            'has-click': step > 1,
            'is-active': step === 1 || step === 2,
          }"
        >
          {{ $t("global.credits") }}
        </button>
        <button
          @click="setStep(2)"
          :class="{
            'has-click': step > 3,
            'is-active': step === 3 || step === 4,
          }"
        >
          {{ $t("global.payment") }}
        </button>
        <button :class="{ 'is-active': step === 5 }">
          {{ $t("global.confirmation") }}
        </button>
      </header>

      <fieldset v-if="isLoading">
        <p class="loading">{{ $t("global.loading") }}</p>
      </fieldset>

      <fieldset v-else-if="step === 1">
        <p class="info">
          {{ $t("balance.typeOfVehicle") }} {{ $root.app.service }}?
        </p>
        <zul-button
          class="is-large"
          v-for="p in productTypes"
          :key="p.productType"
          :data="{}"
          @click="setProductType(p.productType)"
        >
          <span
            slot="icon"
            :class="{
              icon: true,
              'is-car': p.vehicleType == 'CAR',
              'is-motorcycle': p.vehicleType == 'MOTORCYCLE',
            }"
          ></span>
          {{ p.description }}
        </zul-button>
      </fieldset>

      <fieldset v-else-if="step === 2">
        <div v-if="!app.balanceCad">
          <p class="info">{{ $t("balance.askAmount") }}</p>
          <zul-button
            v-for="p in products"
            :key="p.id"
            :data="{}"
            @click="setProduct(p)"
          >
            <span slot="icon" class="icon is-cad"></span>
            <span class="sub">R$ </span>
            <strong>{{
              p.total | currency("", 2, { decimalSeparator: "," })
            }}</strong>
            <span slot="sub"></span>
          </zul-button>
        </div>
        <div v-else>
          <p class="info">
            {{ $t("balance.askQuantity") }} {{ $root.app.productPlural }}:
          </p>
          <zul-button
            v-for="p in products"
            :key="p.id"
            :data="{}"
            @click="setProduct(p)"
          >
            <span slot="icon" class="icon is-cad"></span>
            {{ p.cads }}
            {{ p.cads | pluralize($root.app.product, $root.app.productPlural) }}
            <span slot="sub"
              ><span class="sub">R$ </span>
              <strong>{{
                p.total | currency("", 2, { decimalSeparator: "," })
              }}</strong></span
            >
          </zul-button>
        </div>
      </fieldset>

      <fieldset v-else-if="step === 3">
        <div v-if="!app.balanceCad">
          <zul-button class="is-view">
            <span slot="icon" class="icon is-cad"></span>
            <span class="sub">R$ </span>
            <strong>{{
              purchaseData.product.total
                | currency("", 2, { decimalSeparator: "," })
            }}</strong>
            <span slot="sub"></span>
          </zul-button>
        </div>
        <div v-else>
          <zul-button class="is-view">
            <span slot="icon" class="icon is-cad"></span>
            {{ purchaseData.product.cads }}
            {{
              purchaseData.product.cads
                | pluralize($root.app.product, $root.app.productPlural)
            }}
            <span slot="sub"
              ><span class="sub">R$ </span>
              <strong>{{
                purchaseData.product.total
                  | currency("", 2, { decimalSeparator: "," })
              }}</strong></span
            >
          </zul-button>
        </div>

        <p class="info">{{ $t("balance.payment.title") }}</p>
        <zul-button
          class="is-large"
          v-for="p in paymentTypes"
          :key="p.type"
          :data="{}"
          @click="setPaymentType(p.type)"
          :disabled="!p.enabled"
        >
          <span
            slot="icon"
            :class="{
              icon: true,
              'is-card': p.type == 'CREDIT' || p.type == 'DEBIT',
              'is-bankslip': p.type == 'BANKSLIP',
            }"
          >
            <svg
              v-if="p.type === 'PIX'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.7317 13.44C11.9423 13.2295 12.3094 13.2288 12.5199 13.44L15.5198 16.4397C16.0746 16.9944 16.8126 17.2999 17.5973 17.2999H17.9587L14.1484 21.1101C12.9619 22.2966 11.0381 22.2966 9.85151 21.1101L6.05229 17.3108H6.64342C7.42813 17.3108 8.1661 17.0053 8.721 16.4507L11.7317 13.44ZM5.20156 7.53994C5.25 7.55819 5.30137 7.57118 5.35621 7.57118H6.64344C7.1847 7.57118 7.7144 7.79064 8.09688 8.17331L11.1079 11.1843C11.3886 11.4648 11.7572 11.6053 12.126 11.6053C12.4946 11.6053 12.8634 11.4648 13.144 11.1841L16.1438 8.18422C16.5262 7.80155 17.056 7.58209 17.5973 7.58209H18.6441C18.702 7.58209 18.7569 7.56939 18.8076 7.54907L21.1101 9.85158C22.2966 11.0381 22.2966 12.9619 21.1101 14.1485L18.8077 16.4509C18.7569 16.4305 18.7021 16.4179 18.6441 16.4179H17.5973C17.056 16.4179 16.5262 16.1985 16.1438 15.8157L13.144 12.8162C12.6004 12.272 11.6518 12.2722 11.1076 12.816L8.09688 15.8267C7.7144 16.2094 7.1847 16.4288 6.64344 16.4288H5.35621C5.30137 16.4288 5.24991 16.4418 5.20147 16.4601L2.88993 14.1485C1.70336 12.9619 1.70336 11.0381 2.88993 9.85158L5.20156 7.53994ZM9.85153 2.88993C11.0381 1.70336 12.9619 1.70336 14.1485 2.88993L17.9586 6.70008H17.5973C16.8126 6.70008 16.0746 7.00562 15.5197 7.56024L12.52 10.5603C12.3026 10.7783 11.9485 10.7774 11.7317 10.5606L8.72093 7.54933C8.16611 6.99471 7.42815 6.68908 6.64344 6.68908H6.05241L9.85153 2.88993Z"
                fill="currentColor"
              />
            </svg>
          </span>

          {{ p.name | lowercase | capitalize }}
        </zul-button>

        <p class="warning">{{ message }}</p>
      </fieldset>

      <fieldset v-else-if="step === 4">
        <div v-if="!app.balanceCad">
          <zul-button class="is-view">
            <span slot="icon" class="icon is-cad"></span>
            <span class="sub">R$ </span>
            <strong>{{
              purchaseData.product.total
                | currency("", 2, { decimalSeparator: "," })
            }}</strong>
            <span slot="sub"></span>
          </zul-button>
        </div>
        <div v-else>
          <zul-button class="is-view">
            <span slot="icon" class="icon is-cad"></span>
            {{ purchaseData.product.cads }}
            {{
              purchaseData.product.cads
                | pluralize($root.app.product, $root.app.productPlural)
            }}
            <span slot="sub"
              ><span class="sub">R$ </span>
              <strong>{{
                purchaseData.product.total
                  | currency("", 2, { decimalSeparator: "," })
              }}</strong></span
            >
          </zul-button>
        </div>

        <template v-if="purchaseData.paymentType === 'credit'">
          <zul-button
            class="is-large"
            :data="{}"
            v-for="p in paymentMethods"
            :key="p.id"
            @click="setPaymentMethod(p)"
          >
            **** **** **** {{ p.lastDigits }}
            <span slot="sub"
              ><img :src="p.processor.image['@2x']" width="60"
            /></span>
          </zul-button>

          <a class="button is-text is-medium" @click="addUserCard('credit')">{{
            $t("balance.newCreditCardButton.title")
          }}</a>
        </template>
        <template v-else>
          <zul-button
            class="is-large"
            :data="{}"
            v-for="p in paymentDebitMethods"
            :key="p.id"
            @click="setPaymentMethod(p)"
          >
            **** **** **** {{ p.lastDigits }}
            <span slot="sub"
              ><img :src="p.processor.image['@2x']" width="60"
            /></span>
          </zul-button>

          <a class="button is-text is-medium" @click="addUserCard('debit')">{{
            $t("balance.newDebitCardButton.title")
          }}</a>
        </template>
      </fieldset>

      <fieldset v-else-if="step === 5">
        <div
          v-if="
            purchaseData.paymentType === 'credit' ||
            purchaseData.paymentType === 'debit'
          "
        >
          <p v-if="!app.balanceCad" class="info">
            {{ purchaseMessage.body }}
          </p>
          <p v-else class="info">
            {{ $t("balance.creditOrDebit.askConfirm1") }}
            {{ purchaseData.product.cads }}
            {{
              purchaseData.product.cads
                | pluralize($root.app.product, $root.app.productPlural)
            }}
            {{ $t("balance.creditOrDebit.askConfirm2") }}
            {{
              purchaseData.paymentType === "credit"
                ? $t("balance.credit")
                : $t("balance.debit")
            }}
            {{ $t("balance.creditOrDebit.askConfirm3") }}
          </p>

          <div class="summary">
            <div v-if="!app.balanceCad">
              <zul-button class="is-view">
                <span slot="icon" class="icon is-cad"></span>
                <span class="sub">R$ </span>
                <strong>{{
                  purchaseData.product.total
                    | currency("", 2, { decimalSeparator: "," })
                }}</strong>
                <span slot="sub"></span>
              </zul-button>
            </div>
            <div v-else>
              <zul-button class="is-view">
                <span slot="icon" class="icon is-cad"></span>
                {{ purchaseData.product.cads }}
                {{
                  purchaseData.product.cads
                    | pluralize($root.app.product, $root.app.productPlural)
                }}
                <span slot="sub"
                  ><span class="sub">R$ </span>
                  <strong>{{
                    purchaseData.product.total
                      | currency("", 2, { decimalSeparator: "," })
                  }}</strong></span
                >
              </zul-button>
            </div>
            <zul-button class="is-view is-large is-secondary">
              **** **** **** {{ purchaseData.card.lastDigits }}
              <span slot="sub"
                ><img
                  :src="purchaseData.card.processor.image['@2x']"
                  width="60"
              /></span>
            </zul-button>
            <p class="warning">{{ message }}</p>
          </div>
        </div>
        <div v-else-if="purchaseData.paymentType === 'bankslip'">
          <p v-if="!app.balanceCad" class="info">
            {{ $t("balance.bankslip.askConfirm1") }}
            {{
              purchaseData.product.total
                | currency("", 2, { decimalSeparator: "," })
            }}
            {{ $t("balance.bankslip.askConfirm2") }}
          </p>
          <p v-else class="info">
            {{ $t("balance.bankslip.askConfirm3") }}
            {{ purchaseData.product.cads }}
            {{
              purchaseData.product.cads
                | pluralize($root.app.product, $root.app.productPlural)
            }}
            {{ $t("balance.bankslip.askConfirm4") }}
          </p>

          <div class="summary">
            <div v-if="!app.balanceCad">
              <zul-button class="is-view">
                <span slot="icon" class="icon is-cad"></span>
                <span class="sub">R$ </span>
                <strong>{{
                  purchaseData.product.total
                    | currency("", 2, { decimalSeparator: "," })
                }}</strong>
                <span slot="sub"></span>
              </zul-button>
            </div>
            <div v-else>
              <zul-button class="is-view">
                <span slot="icon" class="icon is-cad"></span>
                {{ purchaseData.product.cads }}
                {{
                  purchaseData.product.cads
                    | pluralize($root.app.product, $root.app.productPlural)
                }}
                <span slot="sub"
                  ><span class="sub">R$ </span>
                  <strong>{{
                    purchaseData.product.total
                      | currency("", 2, { decimalSeparator: "," })
                  }}</strong></span
                >
              </zul-button>
            </div>
            <zul-button class="is-view is-large is-secondary">
              <span slot="icon" class="icon is-bankslip"></span>
              {{ $t("bankslip.title") }}
            </zul-button>

            <div class="warning">
              <h3 class="title">{{ $t("bankslip.warning.title") }}</h3>
              <p>
                {{ $t("bankslip.warning.message", [$root.app.productPlural]) }}
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <p v-if="!app.balanceCad" class="info">
            {{ $t("balance.pix.askConfirm1") }}
            {{
              purchaseData.product.total
                | currency("", 2, { decimalSeparator: "," })
            }}
            {{ $t("balance.pix.askConfirm2") }}
          </p>
          <p v-else class="info">
            {{ $t("balance.pix.askConfirm3") }} {{ purchaseData.product.cads }}
            {{
              purchaseData.product.cads
                | pluralize($root.app.product, $root.app.productPlural)
            }}
            {{ $t("balance.pix.askConfirm4") }}
          </p>

          <div class="summary">
            <div v-if="!app.balanceCad">
              <zul-button class="is-view">
                <span slot="icon" class="icon is-cad"></span>
                <span class="sub">R$ </span>
                <strong>{{
                  purchaseData.product.total
                    | currency("", 2, { decimalSeparator: "," })
                }}</strong>
                <span slot="sub"></span>
              </zul-button>
            </div>
            <div v-else>
              <zul-button class="is-view">
                <span slot="icon" class="icon is-cad"></span>
                {{ purchaseData.product.cads }}
                {{
                  purchaseData.product.cads
                    | pluralize($root.app.product, $root.app.productPlural)
                }}
                <span slot="sub"
                  ><span class="sub">R$ </span>
                  <strong>{{
                    purchaseData.product.total
                      | currency("", 2, { decimalSeparator: "," })
                  }}</strong></span
                >
              </zul-button>
            </div>
            <zul-button class="is-view is-large is-secondary">
              <span slot="icon" class="icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.7317 13.44C11.9423 13.2295 12.3094 13.2288 12.5199 13.44L15.5198 16.4397C16.0746 16.9944 16.8126 17.2999 17.5973 17.2999H17.9587L14.1484 21.1101C12.9619 22.2966 11.0381 22.2966 9.85151 21.1101L6.05229 17.3108H6.64342C7.42813 17.3108 8.1661 17.0053 8.721 16.4507L11.7317 13.44ZM5.20156 7.53994C5.25 7.55819 5.30137 7.57118 5.35621 7.57118H6.64344C7.1847 7.57118 7.7144 7.79064 8.09688 8.17331L11.1079 11.1843C11.3886 11.4648 11.7572 11.6053 12.126 11.6053C12.4946 11.6053 12.8634 11.4648 13.144 11.1841L16.1438 8.18422C16.5262 7.80155 17.056 7.58209 17.5973 7.58209H18.6441C18.702 7.58209 18.7569 7.56939 18.8076 7.54907L21.1101 9.85158C22.2966 11.0381 22.2966 12.9619 21.1101 14.1485L18.8077 16.4509C18.7569 16.4305 18.7021 16.4179 18.6441 16.4179H17.5973C17.056 16.4179 16.5262 16.1985 16.1438 15.8157L13.144 12.8162C12.6004 12.272 11.6518 12.2722 11.1076 12.816L8.09688 15.8267C7.7144 16.2094 7.1847 16.4288 6.64344 16.4288H5.35621C5.30137 16.4288 5.24991 16.4418 5.20147 16.4601L2.88993 14.1485C1.70336 12.9619 1.70336 11.0381 2.88993 9.85158L5.20156 7.53994ZM9.85153 2.88993C11.0381 1.70336 12.9619 1.70336 14.1485 2.88993L17.9586 6.70008H17.5973C16.8126 6.70008 16.0746 7.00562 15.5197 7.56024L12.52 10.5603C12.3026 10.7783 11.9485 10.7774 11.7317 10.5606L8.72093 7.54933C8.16611 6.99471 7.42815 6.68908 6.64344 6.68908H6.05241L9.85153 2.88993Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              Pix
            </zul-button>

            <div class="warning">
              <h3 class="title">{{ $t("balance.pix.warning.title") }}</h3>
              <p v-html="$t('balance.pix.warning.message')"></p>
            </div>
          </div>
        </div>
      </fieldset>
    </zul-modal>

    <zul-modal
      :class="{
        'is-medium': purchaseData.paymentType === 'bankslip',
      }"
      ref="confirmModal"
      type="neutral"
      primary="Fechar"
      @primary="close"
    >
      <fieldset v-if="isLoading">
        <p class="loading">{{ $t("global.loading") }}</p>
      </fieldset>

      <fieldset
        v-else-if="purchaseResult && purchaseData.paymentType === 'bankslip'"
      >
        <h2 class="title">{{ $t("balance.bankslipPending.title") }}</h2>

        <p class="info">
          {{ $t("balance.bankslipPending.info", [$root.app.service]) }}
        </p>
        <p class="info">
          {{ $t("balance.bankslipPending.dueDate") }}
          <strong>{{ purchaseResult.dueDate }}</strong>
        </p>

        <div class="summary">
          <bankslip :data="purchaseResult"></bankslip>
        </div>
      </fieldset>

      <fieldset v-else>
        <span class="icon is-success-order"></span>
        <h2 class="title">{{ $t("balance.success.title") }}</h2>
        <p>{{ $t("balance.success.info", [$root.app.service]) }}</p>
      </fieldset>
    </zul-modal>
    <PixModal ref="pixConfirmModal" :order="purchaseResult"></PixModal>
    <ThreeDsAuth ref="threeDsAuth" />
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import Cad from "../../components/Cad.vue";
import Bankslip from "../../components/Bankslip.vue";
import ZulButton from "../../components/Button.vue";
import PixModal from "../../components/Pix.vue";

import ThreeDsAuth from "../../modals/ThreeDsAuth.vue";

import config from "config";
import { getBrowserInfo } from "@zuldigital/classic-adyen-3ds";

export default {
  props: {},
  data() {
    return {
      step: 1,
      isLoading: false,
      funds: [],
      fundsFiltered: [],
      vehicles: [], // Saldo atrelado aos veiculos
      currentProduct: {},
      purchaseData: {},
      purchaseResult: {},
      paymentMethods: [],
      paymentDebitMethods: [],
      paymentTypes: [],
      productTypes: [],
      purchaseMessage: null,
      products: {
        CAD: [],
        CAD_BONUS: [],
      },
      message: null,
      modalTitle: "Comprar " + this.$root.app.productPlural,
    };
  },
  created() {
    this.loadFunds();

    /*this.$http.get('order/products')
      .then(res => {}) // Prooduct Types (error 428)*/

    this.paymentMethods = this.$auth
      .user()
      .paymentMethods.filter((p) => p.type === "CREDIT");
    this.paymentDebitMethods = this.$auth
      .user()
      .paymentMethods.filter((p) => p.type === "DEBIT");

    this.$root.$on("update-user-funds", () => {
      this.loadFunds();
    });

    this.$root.$on("cancel-bankslip-start", () => {
      this.isLoading = true;

      if (this.$refs.confirmModal) {
        this.$refs.confirmModal.setProps({
          title: "Cancelando Boleto",
          labels: { primary: null },
        });
      }
    });

    this.$root.$on("cancel-bankslip-end", () => {
      this.isLoading = false;

      if (this.$refs.confirmModal) {
        this.$refs.confirmModal.close();
      }
    });
  },
  methods: {
    loadFunds() {
      this.$http.get("order/funds").then((res) => {
        this.funds = res.data.funds.map((o) => {
          o.key = o.type + o.vehicleType;
          return o;
        });

        this.fundsFiltered = this.funds.slice(0);

        if (this.fundsFiltered[2]) {
          //this.funds[1]
          this.fundsFiltered[2].title = "Moto";
          this.fundsFiltered.splice(1, 1);
        }

        this.vehicles = res.data.vehicles;
      });

      // update user funds (SSA)
      this.$auth.fetch({
        success: (res) => {
          this.$auth.user(res.data);
        },
      });
    },

    addUserCard(type) {
      this.$refs.purchaseModal.close();
      this.$root.$emit("add-user-card", type);
      this.$root.$on("add-user-card-end", () => {
        this.loadUserPaymentMethods();
        this.$refs.purchaseModal.open();
      });
    },

    loadUserPaymentMethods() {
      this.paymentMethods = this.$auth
        .user()
        .paymentMethods.filter((p) => p.type === "CREDIT");
      this.paymentDebitMethods = this.$auth
        .user()
        .paymentMethods.filter((p) => p.type === "DEBIT");
    },

    view() {
      this.$refs.purchaseModal.close();
      this.$refs.balanceModal.open();
    },

    purchase() {
      this.$refs.balanceModal.close();
      this.$refs.purchaseModal.open();

      this.loadUserPaymentMethods();

      // reset step
      this.step = 1;
      this.currentProduct = {};
      this.purchaseData = {};
      this.paymentTypes = [];
      this.productTypes = [];
      this.message = null;
      this.$refs.confirmModal.setProps({
        title: "",
        type: "neutral",
        labels: { primary: this.$t("global.close") },
      });
      this.$refs.purchaseModal.setProps({ labels: { primary: null } });

      this.isLoading = true;

      this.$http.get(`order/products`).then(
        (res) => {
          this.isLoading = false;
          this.products = res.data.products;
          this.step = 2;
        },
        (err) => {
          this.isLoading = false;

          if (err.response.status === 428) {
            this.productTypes = err.response.data;
          }
        }
      );
    },

    setStep(p) {
      if (p === 1 && this.step > 1) {
        this.productTypes.length === 0 ? (this.step = 2) : (this.step = 1);
        this.$refs.purchaseModal.setProps({ labels: { primary: null } });
      } else if (p === 2 && this.step > 3) {
        this.step = 3;
        this.$refs.purchaseModal.setProps({ labels: { primary: null } });
      }
    },

    // Step 1 - Choose productType
    setProductType(type) {
      this.isLoading = true;

      this.$http.get(`order/products?type=${type}`).then((res) => {
        this.isLoading = false;
        this.products = res.data;
        this.step++;
      });
    },

    // Step 2 - Choose product
    setProduct(product) {
      this.currentProduct = product;
      this.purchaseData.product = product;
      this.isLoading = true;

      this.$http
        .get(`/order/paymenttypes?action=ORDER&productId=${product.id}`)
        .then((res) => {
          this.isLoading = false;
          this.paymentTypes = res.data.items.filter(
            (o) =>
              o.type === "BANKSLIP" ||
              o.type === "PIX" ||
              o.type === "DEBIT" ||
              (o.type === "CREDIT" && !o.wallet)
          );
          this.message = res.data.message;
          this.step++;
        });
    },

    // Step 3 - Choose payment method (credit or bankslip)
    setPaymentType(type) {
      type = type.toLowerCase();
      this.purchaseData.paymentType = type;

      // reset message
      this.message = null;

      if (type === "credit" || type === "debit") {
        this.step++;

        if (
          (type === "credit" && this.paymentMethods.length === 0) ||
          (type === "debit" && this.paymentDebitMethods.length === 0)
        ) {
          this.addUserCard(type);
        }
      } else if (type === "bankslip") {
        this.step = 5;
        this.$refs.purchaseModal.setProps({ labels: { primary: "Confirmar" } });
      } else if (type === "pix") {
        this.step = 5;
        this.$refs.purchaseModal.setProps({
          labels: { primary: "Gerar código PIX" },
        });
      }
    },

    // Step 4 - Choose credit card
    setPaymentMethod(card) {
      this.purchaseData.card = card;
      this.isLoading = true;

      this.$http
        .get(
          `/user/payment/${this.purchaseData.card.id}?productId=${this.purchaseData.product.id}`
        )
        .then((res) => {
          this.purchaseMessage = res.data.message;

          this.step++;
          this.$refs.purchaseModal.setProps({
            labels: { primary: this.$t("global.confirm") },
          });
          this.isLoading = false;
        });
    },
    // Final Step
    confirm() {
      const data = new FormData();

      if (
        this.purchaseData.paymentType === "credit" ||
        this.purchaseData.paymentType === "debit"
      ) {
        data.append("productId", this.purchaseData.product.id);
        data.append("paymentMethodId", this.purchaseData.card.id);
        data.append("paymentSource", this.purchaseData.card.gateway);
      } else if (this.purchaseData.paymentType === "bankslip") {
        data.append("productId", this.purchaseData.product.id);
        data.append("email", this.$auth.user().email);
      } else {
        const redeemCode =
          (
            (
              this.paymentTypes.find(
                (payment) => payment.type.toLowerCase() === "pix"
              ) || {}
            ).redeem || {}
          ).code || null;

        data.append("productId", this.purchaseData.product.id);

        if (redeemCode) {
          data.append("redeemCode", redeemCode);
        }
      }

      this.$refs.purchaseModal.startLoading();
      this.message = null;

      let paymentEndpoint;

      if (this.purchaseData.paymentType === "debit") {
        paymentEndpoint = "debit-pinless";
      } else {
        paymentEndpoint = this.purchaseData.paymentType;
      }

      if (["credit", "debit"].includes(paymentEndpoint)) {
        data.append("browserInfo", JSON.stringify({ ...getBrowserInfo() }));
        data.append(
          "notificationURL",
          `${config.API_URL.replace("/v7", "")}/external/payment/3ds/challenge`
        );
      }

      this.$http.post(`order/${paymentEndpoint}`, data).then(
        (res) => {
          this.$refs.purchaseModal.stopLoading();

          if (res.status === 200) {
            if (
              ["AUTH_FINGERPRINT", "AUTH_CHALLENGE"].includes(res.data.status)
            ) {
              const { id, category, status } = res.data;

              this.$refs.threeDsAuth
                .open({
                  id,
                  category,
                  status,
                })
                .then(() => {
                  this.loadFunds();
                  this.$root.$emit("reload-historic");

                  this.$refs.threeDsAuth.close();
                })
                .catch((error) => {
                  this.$buefy.toast.open({
                    message:
                      typeof error === "string"
                        ? error
                        : "Erro ao autenticar cartão.",
                    type: "is-danger",
                  });
                });
            }

            this.purchaseResult = res.data;

            if (this.purchaseData.paymentType === "pix") {
              this.$root.$emit("set-pending-order", this.purchaseResult);
              this.$refs.pixConfirmModal.open(false);

              this.$refs.purchaseModal.close();
              return;
            } else if (this.purchaseData.paymentType === "bankslip") {
              this.purchaseResult.product =
                this.purchaseData.product || this.currentProduct;
              this.$root.$emit("set-pending-order", this.purchaseResult);
            } else {
              this.loadFunds();
              this.$root.$emit("reload-historic");
            }

            this.$refs.purchaseModal.close();
            this.$refs.confirmModal.open();
          }
        },
        (err) => {
          const message =
            (((err || {}).response || {}).data || {}).message ||
            this.$t("global.error.message");

          this.$refs.purchaseModal.stopLoading();

          this.$buefy.toast.open({
            message,
            type: "is-danger",
          });

          this.setStep(1);
        }
      );
    },

    close() {
      this.$refs.confirmModal.close();
    },
  },
  components: {
    Cad,
    Bankslip,
    ZulButton,
    QrcodeVue,
    PixModal,
    ThreeDsAuth,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/sass/variables";

.balance-wrap {
  height: 100%;
  padding-bottom: 1px;
}

.box {
  margin-bottom: 1px !important;
}

.title {
  .button.is-text {
    font-size: 0.7rem;
    height: 1rem;
    padding: 0.55rem 0.9rem 0.5rem 0.25rem;

    background: transparent $extIcon no-repeat right center;
  }
}

.button.is-primary {
  position: absolute;
  right: 2rem;
  top: 2.5rem;

  padding: 0.75rem 3rem 0.75rem 1rem;
  font-size: $size-6;
  height: 3rem;

  background: transparent $orderWhiteIcon no-repeat 87% center;

  @each $city, $map in $cities {
    .is-#{$city} & {
      background-color: map-get($map, "primary");
    }
  }
}

.balance-modal {
  .title {
    font-size: 1rem;
    text-transform: uppercase;
    background-size: contain;

    &.has-icon {
      padding-left: 3rem;
      background-repeat: no-repeat;
      background-position: 10px center;

      &.car {
        background-image: $carIcon;
      }
      &.motorcycle {
        background-image: $motorcycleIcon;
        background-position: 19px center;
      }
    }
  }
}

// steps
.order-steps {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;

  button {
    background: transparent;
    color: $grey;
    border: none;
    font-size: $size-6;
    outline: none;

    &:after {
      content: " ";
      display: block;
      height: 2px;
      width: 14px;
      background: $black;
      margin: 9px auto;
    }

    &.has-click {
      cursor: pointer;
    }

    &.is-active {
      color: $white;

      &:after {
        @each $city, $map in $cities {
          .is-#{$city} & {
            background: map-get($map, "primary");
          }
        }
      }
    }
  }
}

fieldset {
  border: none;
  text-align: center;

  .title {
    font-size: $size-5;
    text-transform: uppercase;
  }

  .info {
    font-size: $size-6;
    margin: 0.75rem 2rem 1.5rem;
  }

  .sub {
    opacity: 0.5;
  }

  .is-view {
    margin: 0.75rem 0 1.5rem;
  }

  .summary {
    .is-view {
      margin: 0;
    }
  }

  .warning {
    padding: 0.75rem 1.5rem 0.5rem;
    font-size: $size-7;

    .title {
      font-size: $size-6;
      text-transform: uppercase;
    }
  }

  .is-success-order {
    display: inline-block;
    margin-bottom: 2rem;
  }

  // big modal
  .is-large & {
    .warning {
      padding: 0.75rem 3rem 0.5rem;
    }
  }
}

h3.title {
  margin-top: 18px;
  margin-bottom: 10px;
}

.balance {
  display: inline-block;
  padding-right: 10px;
  padding-left: 27px;

  background: transparent no-repeat left center;

  span {
    font-weight: bold;
  }

  &.is-regular {
    background-image: $cadIcon;
  }

  &.is-bonus {
    background-image: $cadBonusIcon;
  }
}

.loading {
  background: url("../../assets/loading.svg") no-repeat center 35%;
  background-size: 100px;
  text-align: center;
  padding: 7rem 0 0;
  font-size: $size-7;
  opacity: 0.5;
  margin-right: 0;
}
</style>
